export default __webpack_public_path__ + "static/media/higher_icon_wallet.cefa21f5.svg";